import script from "./DocumentosEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentosEvento.vue?vue&type=script&setup=true&lang=js"

import "./DocumentosEvento.vue?vue&type=style&index=0&id=82c1386c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82c1386c"]])

export default __exports__